import { lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { AdminRoute } from './AdminRoute'
import { S } from './lazyWrap'

// AppLayout altındaki korumalı modül route'ları — TEK KAYNAK.
// Hem web BrowserRouter (router/index.tsx) hem de masaüstü MDI çalışma alanı
// (layouts/workspace/AppRoutes.tsx → useRoutes) bu diziyi aynı şekilde tüketir.
// Web davranışı birebir korunur; masaüstü bunu sekme içi router'da kullanır.

const DashboardPage = lazy(() => import('@/modules/dashboard/pages/DashboardPage'))
const StokListePage = lazy(() => import('@/modules/stok/pages/StokListePage'))
const StokKartPage = lazy(() => import('@/modules/stok/pages/StokKartPage'))
const StokHareketleriPage = lazy(() => import('@/modules/stok/pages/StokHareketleriPage'))
const StokSayimPage = lazy(() => import('@/modules/stok/pages/StokSayimPage'))
const CariListePage = lazy(() => import('@/modules/cari/pages/CariListePage'))
const CariKartPage = lazy(() => import('@/modules/cari/pages/CariKartPage'))
const CariHareketleriPage = lazy(() => import('@/modules/cari/pages/CariHareketleriPage'))
const FaturaListePage = lazy(() => import('@/modules/fatura/pages/FaturaListePage'))
const FaturaOlusturPage = lazy(() => import('@/modules/fatura/pages/FaturaOlusturPage'))
const FaturaTipListePage = lazy(() => import('@/modules/fatura/pages/FaturaTipListePage'))
const FaturaTipOlusturPage = lazy(() => import('@/modules/fatura/pages/FaturaTipOlusturPage'))
const KasaPage = lazy(() => import('@/modules/kasa/pages/KasaPage'))
const BankaPage = lazy(() => import('@/modules/banka/pages/BankaPage'))
const CekListePage = lazy(() => import('@/modules/cek/pages/CekListePage'))
const TaksitListesiPage = lazy(() => import('@/modules/taksit/pages/TaksitListesiPage'))
const TaksitPlaniDetayPage = lazy(() => import('@/modules/taksit/pages/TaksitPlaniDetayPage'))
const SiparisListePage = lazy(() => import('@/modules/siparis/pages/SiparisListePage'))
const SiparisOlusturPage = lazy(() => import('@/modules/siparis/pages/SiparisOlusturPage'))
const RaporlarPage = lazy(() => import('@/modules/raporlar/pages/RaporlarPage'))
const RaporBuilderGaleriPage = lazy(() => import('@/modules/raporlar/pages/builder/GaleriPage'))
const ViewOlusturPage = lazy(() => import('@/modules/raporlar/pages/builder/ViewOlusturPage'))
const RaporOlusturPage = lazy(() => import('@/modules/raporlar/pages/builder/RaporOlusturPage'))
const RaporCalistirPage = lazy(() => import('@/modules/raporlar/pages/builder/RaporCalistirPage'))

const DonemYonetimPage = lazy(() => import('@/modules/donem/pages/DonemYonetimPage'))

const AyarlarPage = lazy(() => import('@/modules/ayarlar/pages/AyarlarPage'))
const FirmaBilgileriPage = lazy(() => import('@/modules/ayarlar/pages/FirmaBilgileriPage'))
const FirmalarimPage = lazy(() => import('@/modules/ayarlar/pages/FirmalarimPage'))
const KullanicilarPage = lazy(() => import('@/modules/ayarlar/pages/KullanicilarPage'))
const GenelAyarlarPage = lazy(() => import('@/modules/ayarlar/pages/GenelAyarlarPage'))
const HizliSatisAyarlariPage = lazy(() => import('@/modules/ayarlar/pages/HizliSatisAyarlariPage'))
const SiparisAyarlariPage = lazy(() => import('@/modules/ayarlar/pages/SiparisAyarlariPage'))
const DovizKurlariPage = lazy(() => import('@/modules/ayarlar/pages/DovizKurlariPage'))
const VeriAktarimPage = lazy(() => import('@/modules/ayarlar/pages/VeriAktarimPage'))
const EtiketAyarlariPage = lazy(() => import('@/modules/ayarlar/pages/EtiketAyarlariPage'))
const AbonelikPage = lazy(() => import('@/modules/ayarlar/pages/AbonelikPage'))
const DenetimKayitPage = lazy(() => import('@/modules/ayarlar/pages/DenetimKayitPage'))
const HesapKapatmaPage = lazy(() => import('@/modules/ayarlar/pages/HesapKapatmaPage'))
const ProfilPage = lazy(() => import('@/modules/ayarlar/pages/ProfilPage'))
const FaturalarimPage = lazy(() => import('@/modules/ayarlar/pages/FaturalarimPage'))
const VeriIndirPage = lazy(() => import('@/modules/ayarlar/pages/VeriIndirPage'))
const SubelerPage = lazy(() => import('@/modules/ayarlar/pages/SubelerPage'))
const DepolarPage = lazy(() => import('@/modules/ayarlar/pages/DepolarPage'))

const PosSatisGecmisiPage = lazy(() => import('@/modules/pos/pages/PosSatisGecmisiPage'))
const EBelgePage = lazy(() => import('@/modules/ebelge/pages/EBelgePage'))
const BillingSuccessPage = lazy(() => import('@/modules/billing/pages/BillingSuccessPage'))
const BillingCancelPage = lazy(() => import('@/modules/billing/pages/BillingCancelPage'))

const AdminFirmaListesiPage = lazy(() => import('@/modules/admin/pages/AdminFirmaListesiPage'))
const AdminHesaplarPage = lazy(() => import('@/modules/admin/pages/AdminHesaplarPage'))
const AdminDashboardPage = lazy(() => import('@/modules/admin/pages/AdminDashboardPage'))
const AdminPlanlarPage = lazy(() => import('@/modules/admin/pages/AdminPlanlarPage'))
const AdminYedeklerPage = lazy(() => import('@/modules/admin/pages/AdminYedeklerPage'))

const ServisListePage = lazy(() => import('@/modules/servis/pages/ServisListePage'))
const ServisKayitPage = lazy(() => import('@/modules/servis/pages/ServisKayitPage'))
const VarlikListePage = lazy(() => import('@/modules/servis/pages/VarlikListePage'))
const VarlikGecmisPage = lazy(() => import('@/modules/servis/pages/VarlikGecmisPage'))
const ServisTeknisyenlerPage = lazy(() => import('@/modules/ayarlar/pages/ServisTeknisyenlerPage'))

const DepoTransferListePage = lazy(() => import('@/modules/depo/pages/DepoTransferListePage'))
const DepoTransferOlusturPage = lazy(() => import('@/modules/depo/pages/DepoTransferOlusturPage'))
const DepoFisListePage = lazy(() => import('@/modules/depo/pages/DepoFisListePage'))
const DepoFisOlusturPage = lazy(() => import('@/modules/depo/pages/DepoFisOlusturPage'))

export const appRouteObjects: RouteObject[] = [
  { path: 'dashboard', element: <S><DashboardPage /></S> },

  // Stok (sabit route'lar :id'den önce)
  { path: 'stok', element: <S><StokListePage /></S> },
  { path: 'stok/hareketler', element: <S><StokHareketleriPage /></S> },
  { path: 'stok/sayim', element: <S><StokSayimPage /></S> },
  { path: 'stok/giris-cikis', element: <S><DepoFisListePage /></S> },
  { path: 'stok/giris-cikis/yeni', element: <S><DepoFisOlusturPage /></S> },
  { path: 'stok/giris-cikis/:id', element: <S><DepoFisOlusturPage /></S> },
  { path: 'stok/giris-cikis/:id/duzenle', element: <S><DepoFisOlusturPage editMode /></S> },
  { path: 'stok/yeni', element: <S><StokKartPage mode="create" /></S> },
  { path: 'stok/:id', element: <S><StokKartPage mode="view" /></S> },
  { path: 'stok/:id/duzenle', element: <S><StokKartPage mode="edit" /></S> },

  // Servis / Arıza takibi (sabit route'lar :id'den önce)
  { path: 'servis', element: <S><ServisListePage /></S> },
  { path: 'servis/yeni', element: <S><ServisKayitPage /></S> },
  { path: 'servis/varliklar', element: <S><VarlikListePage /></S> },
  { path: 'servis/varliklar/:id/gecmis', element: <S><VarlikGecmisPage /></S> },
  { path: 'servis/teknisyenler', element: <S><ServisTeknisyenlerPage /></S> },
  { path: 'servis/:id', element: <S><ServisKayitPage /></S> },

  // Cari (sabit route'lar :id'den önce)
  { path: 'cari', element: <S><CariListePage /></S> },
  { path: 'cari/hareketler', element: <S><CariHareketleriPage /></S> },
  { path: 'cari/yeni', element: <S><CariKartPage mode="create" /></S> },
  { path: 'cari/:id', element: <S><CariKartPage mode="view" /></S> },
  { path: 'cari/:id/duzenle', element: <S><CariKartPage mode="edit" /></S> },

  // Fatura (sabit route'lar :id'den önce)
  { path: 'fatura', element: <S><FaturaListePage /></S> },
  { path: 'fatura/yeni', element: <S><FaturaOlusturPage /></S> },
  { path: 'fatura/alis-irsaliye',       element: <S><FaturaTipListePage tipKey="alis-irsaliye" /></S> },
  { path: 'fatura/alis-irsaliye/yeni',  element: <S><FaturaTipOlusturPage tipKey="alis-irsaliye" /></S> },
  { path: 'fatura/satis-irsaliye',      element: <S><FaturaTipListePage tipKey="satis-irsaliye" /></S> },
  { path: 'fatura/satis-irsaliye/yeni', element: <S><FaturaTipOlusturPage tipKey="satis-irsaliye" /></S> },
  { path: 'fatura/alis',                element: <S><FaturaTipListePage tipKey="alis" /></S> },
  { path: 'fatura/alis/yeni',           element: <S><FaturaTipOlusturPage tipKey="alis" /></S> },
  { path: 'fatura/satis',               element: <S><FaturaTipListePage tipKey="satis" /></S> },
  { path: 'fatura/satis/yeni',          element: <S><FaturaTipOlusturPage tipKey="satis" /></S> },
  { path: 'fatura/alis-iade',           element: <S><FaturaTipListePage tipKey="alis-iade" /></S> },
  { path: 'fatura/alis-iade/yeni',      element: <S><FaturaTipOlusturPage tipKey="alis-iade" /></S> },
  { path: 'fatura/satis-iade',          element: <S><FaturaTipListePage tipKey="satis-iade" /></S> },
  { path: 'fatura/satis-iade/yeni',     element: <S><FaturaTipOlusturPage tipKey="satis-iade" /></S> },

  // Diğer modüller
  { path: 'kasa', element: <S><KasaPage /></S> },
  { path: 'kasa/hareketler', element: <Navigate to="/kasa" replace /> },
  { path: 'banka', element: <S><BankaPage /></S> },
  { path: 'banka/hareketler', element: <Navigate to="/banka" replace /> },
  { path: 'cek', element: <S><CekListePage /></S> },
  { path: 'taksit', element: <S><TaksitListesiPage /></S> },
  { path: 'taksit/:planId', element: <S><TaksitPlaniDetayPage /></S> },
  { path: 'siparis',                        element: <S><SiparisListePage tip="satis" /></S> },
  { path: 'siparis/yeni',                    element: <S><SiparisOlusturPage tip="satis" /></S> },
  { path: 'siparis/satin-alma',              element: <S><SiparisListePage tip="alis" /></S> },
  { path: 'siparis/satin-alma/yeni',         element: <S><SiparisOlusturPage tip="alis" /></S> },
  { path: 'siparis/satin-alma/:id',          element: <S><SiparisOlusturPage tip="alis" /></S> },
  { path: 'siparis/satin-alma/:id/duzenle',  element: <S><SiparisOlusturPage tip="alis" editMode /></S> },
  { path: 'siparis/:id/duzenle',             element: <S><SiparisOlusturPage tip="satis" editMode /></S> },
  { path: 'siparis/:id',                     element: <S><SiparisOlusturPage tip="satis" /></S> },
  { path: 'hizli-satis/gecmis', element: <S><PosSatisGecmisiPage /></S> },
  { path: 'raporlar', element: <S><RaporlarPage /></S> },

  // e-Belge (firma e-belge aktifse sidebar'da görünür; RBAC ile korunur)
  { path: 'ebelge/e-fatura', element: <S><EBelgePage tip="efatura" /></S> },
  { path: 'ebelge/e-arsiv', element: <S><EBelgePage tip="earsiv" /></S> },
  { path: 'ebelge/e-irsaliye', element: <S><EBelgePage tip="eirsaliye" /></S> },

  // Rapor Builder
  { path: 'raporlar/builder', element: <S><RaporBuilderGaleriPage /></S> },
  { path: 'raporlar/builder/view/yeni', element: <S><ViewOlusturPage /></S> },
  { path: 'raporlar/builder/view/:id', element: <S><ViewOlusturPage /></S> },
  { path: 'raporlar/builder/rapor/yeni', element: <S><RaporOlusturPage /></S> },
  { path: 'raporlar/builder/rapor/:id', element: <S><RaporOlusturPage /></S> },
  { path: 'raporlar/builder/calistir/:raporId', element: <S><RaporCalistirPage /></S> },

  // Depo Transfer
  { path: 'depo/transfer', element: <S><DepoTransferListePage /></S> },
  { path: 'depo/transfer/yeni', element: <S><DepoTransferOlusturPage /></S> },
  { path: 'depo/transfer/:id', element: <S><DepoTransferOlusturPage /></S> },
  { path: 'depo/transfer/:id/duzenle', element: <S><DepoTransferOlusturPage editMode /></S> },

  // Ayarlar (nested)
  {
    path: 'ayarlar',
    element: <S><AyarlarPage /></S>,
    children: [
      { path: 'profil', element: <S><ProfilPage /></S> },
      { path: 'firmalar', element: <S><FirmalarimPage /></S> },
      { path: 'firma', element: <S><FirmaBilgileriPage /></S> },
      { path: 'kullanicilar', element: <S><KullanicilarPage /></S> },
      { path: 'donem', element: <S><DonemYonetimPage /></S> },
      { path: 'genel', element: <S><GenelAyarlarPage /></S> },
      // Eski route'lar — Genel Ayarlar'a redirect (bookmark/link bozulmasın)
      { path: 'belge-serileri', element: <Navigate to="/ayarlar/genel?tab=belge-serileri" replace /> },
      { path: 'olcu-birimleri', element: <Navigate to="/ayarlar/genel?tab=olcu-birimleri" replace /> },
      { path: 'tevkifat', element: <Navigate to="/ayarlar/genel?tab=tevkifat" replace /> },
      { path: 'kod-tanimlama', element: <Navigate to="/ayarlar/genel?tab=kod-tanimlama" replace /> },
      { path: 'grup-kod-tanimlama', element: <Navigate to="/ayarlar/genel?tab=grup-kod-tanimlama" replace /> },
      { path: 'rehber-ayarlari', element: <Navigate to="/ayarlar/genel?tab=rehber-ayarlari" replace /> },
      { path: 'hizli-satis', element: <S><HizliSatisAyarlariPage /></S> },
      { path: 'siparis-ayarlari', element: <S><SiparisAyarlariPage /></S> },
      { path: 'doviz-kurlari', element: <S><DovizKurlariPage /></S> },
      { path: 'veri-aktarim', element: <S><VeriAktarimPage /></S> },
      { path: 'etiket', element: <S><EtiketAyarlariPage /></S> },
      { path: 'abonelik', element: <S><AbonelikPage /></S> },
      { path: 'faturalarim', element: <S><FaturalarimPage /></S> },
      { path: 'veri-indir', element: <S><VeriIndirPage /></S> },
      { path: 'denetim-kayit', element: <S><DenetimKayitPage /></S> },
      { path: 'hesap-kapatma', element: <S><HesapKapatmaPage /></S> },
      { path: 'subeler', element: <S><SubelerPage /></S> },
      { path: 'depolar', element: <S><DepolarPage /></S> },
      { path: 'servis-teknisyenler', element: <S><ServisTeknisyenlerPage /></S> },
    ],
  },

  // Billing (Stripe sonuç sayfaları — AppLayout içinde ama tam ekran gibi)
  { path: 'billing/success', element: <S><BillingSuccessPage /></S> },
  { path: 'billing/cancel', element: <S><BillingCancelPage /></S> },

  // Admin
  { path: 'admin', element: <AdminRoute><S><AdminDashboardPage /></S></AdminRoute> },
  { path: 'admin/hesaplar', element: <AdminRoute><S><AdminHesaplarPage /></S></AdminRoute> },
  { path: 'admin/firmalar', element: <AdminRoute><S><AdminFirmaListesiPage /></S></AdminRoute> },
  { path: 'admin/planlar', element: <AdminRoute><S><AdminPlanlarPage /></S></AdminRoute> },
  { path: 'admin/yedekler', element: <AdminRoute><S><AdminYedeklerPage /></S></AdminRoute> },

  // 404
  { path: '*', element: <Navigate to="/dashboard" replace /> },
]
